import { fExecuteAPI } from '../../Server/Apis';

export const getTransSummary = async (xObj) => {
  try {
    const result = await fExecuteAPI('FP_TRANS_SUMMARY', xObj);
    return result.data;
  } catch (error) {}
};

export const getTransItems = async (xObj) => {
  try {
    const result = await fExecuteAPI('FP_TRANS_ITEMS', xObj);
    return result.data;
  } catch (error) {}
};

export const getVendorOSAmt = async (xObj) => {
  try {
    const result = await fExecuteAPI('GET_VENDOR_OS_AMT', xObj);
    return result;
  } catch (error) {}
};

export const getVendorOSDetail = async (xObj) => {
  try {
    const result = await fExecuteAPI('GET_VENDOR_OS_DETAIL', xObj);
    return result;
  } catch (error) {}
};

export const savePurchaseTransaction = async (xObj) => {
  try {
    const result = await fExecuteAPI('SAVE_PURCHASE_TRANS', xObj);
    return result;
  } catch (error) {}
};

export const postPurchaseTransaction = async (xObj) => {
  try {
    const result = await fExecuteAPI('POST_PURCHASE_TRANS', xObj);
    return result;
  } catch (error) {}
};

export const deletePurchaseTransaction = async (xObj) => {
  try {
    const result = await fExecuteAPI('DELETE_PURCHASE_TRANS', xObj);
    return result;
  } catch (error) {}
};

export const reversePurchaseTransaction = async (xObj) => {
  try {
    const result = await fExecuteAPI('REVERSE_PURCHASE_TRANS', xObj);
    return result;
  } catch (error) {}
};
export const searchVendor = async (xObj) => {
  try {
    const result = await fExecuteAPI('SEARCH_VENDOR', xObj);
    return result;
  } catch (error) {}
};
export const searchAdditionalItem = async (xObj) => {
  try {
    const result = await fExecuteAPI('SRCH_ADDITIONAL_ITEM', xObj);
    return result;
  } catch (error) {}
};
export const getBufferItems = async (xObj) => {
  try {
    const result = await fExecuteAPI('FP_BUFFER_ITEMS', xObj);
    return result.data;
  } catch (error) {}
};
export const updateBufferTransaction = async (xObj) => {
  try {
    const result = await fExecuteAPI('FP_UPDATE_BUFFER_TRANS', xObj);
    return result;
  } catch (error) {}
};

export const confirmBufferTransaction = async (xObj) => {
  try {
    const result = await fExecuteAPI('FP_CONFIRM_BUFFER_TRANS', xObj);
    return result;
  } catch (error) {}
};

export const getOrderSummary = async (xObj) => {
  try {
    const result = await fExecuteAPI('FP_ORDER_SUMMARY', xObj);
    return result.data;
  } catch (error) {}
};
export const getOrderItems = async (xObj) => {
  try {
    const result = await fExecuteAPI('FP_ORDER_ITEMS', xObj);
    return result.data;
  } catch (error) {}
};

export const getOrderDetails = async (xObj) => {
  try {
    const result = await fExecuteAPI('FP_ORDER_DETAILS', xObj);
    return result.data;
  } catch (error) {}
};

export const postOrder = async (xObj) => {
  try {
    const result = await fExecuteAPI('FP_POST_ORDER', xObj);
    return result;
  } catch (error) {}
};

export const getOrderItemsReqLocs = async (xObj) => {
  try {
    const result = await fExecuteAPI('FP_ORDER_ITEMS_REQ_LOC', xObj);
    return result.data;
  } catch (error) {}
};
export const reverseConfirmedTransaction = async (xObj) => {
  try {
    const result = await fExecuteAPI('REVERSE_CONFIRMED_TRANS', xObj);
    return result;
  } catch (error) {}
};
